import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '@environments/environment';
import { GlobalDataService } from '@providers/global-data/global-data.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent implements OnInit, OnChanges {
  currentProjectId: string;
  displayMenu: boolean = false;
  currentCategory: string;
  @Input('user') public user: string;
  @Input('closePopups') public closePopups: boolean;
  @Output() openMenu = new EventEmitter();

  constructor(
    private router: Router,
    private globalDataService: GlobalDataService
  ) {
    this.currentProjectId = '';

    this.globalDataService.getCurrentProjectId().subscribe((projectId: string) => {
      this.currentProjectId = projectId;
    });
  }

  ngOnInit() {
    this.currentCategory = 'État du projet';
  }

  ngOnChanges() {
    if (this.closePopups) {
      this.displayMenu = false;
      const popup = document.getElementById('myPopup');
      popup.classList.remove('show');
    }
  }

  public showPopup() {
    const popup = document.getElementById('myPopup');
    popup.classList.toggle('show');
    const isPopupOpen = document.getElementsByClassName('show');
    (isPopupOpen.length > 0)
      ? this.openMenu.emit(true)
      : this.openMenu.emit(false);
    this.displayMenu = false;
    this.closePopups = false;
  }

  public logout() {
    const token = '';
    localStorage.setItem('access_token', token);
    this.globalDataService.token = token;
    localStorage.clear();
    window.open(`${environment.auth_url}/logout`, '_self');
  }

  public goToAccount(): void {
    window.open(`${environment.auth_url}`, '_self');
  }

  public displayMenuBurger(e) {
    if (typeof e !== 'undefined') {
      this.currentCategory = e;
    }
    this.displayMenu = !this.displayMenu;
    this.openMenu.emit(this.displayMenu);
    this.closePopups = false;
  }
}
